export default __webpack_public_path__ + "static/media/WoodMac_logo_interim_RGB.0b60061e.png";